module.exports = __webpack_public_path__ + "img/acreport.1ffb55a8.svg";